<template>
  <div>
    <div class="px-6">
      <v-container class="px-0">
        <div
          class="d-flex justify-space-between align-center flex-lg-row flex-row"
          :class="[
            $vuetify.breakpoint.lgAndDown ? 'mt-3 mb-3' : 'mt-7 mb-7',
            $vuetify.breakpoint.xsAndDown ? 'flex-column' : 'flex-row',
          ]"
        >
          <div
            class="w-100 d-flex align-center justify-space-between top-title"
          >
            <h1 class="font-weight-800">
              {{ $t("heading.billing.title") }}
            </h1>
          </div>
        </div>
      </v-container>
    </div>

    <v-divider
      :class="$vuetify.breakpoint.lgAndDown ? 'mb-3' : 'mb-10'"
    ></v-divider>

    <div class="px-6">
      <NoAvailableInvoicesView v-if="items.length === 0 && !loading" />
      <v-container 
        class="p0-0" 
        v-else
      >
        <v-row
          align="stretch"
          class="mx-0"
          no-gutters
          :class="$vuetify.breakpoint.mobile ? 'mobile-container' : ''"
        >
          <v-col cols="12" lg="2" class="sticky-sidebar">
            <v-card elevation="4">
              <v-card-text>
                <v-row>
                  <v-col>
                    <p class="p-d font-weight-bold text--darken2 mb-0">
                      {{ $t('heading.billing.details.title') }}
                    </p>
                    <v-divider class="mt-2 mb-3" />
                    <v-progress-linear v-if="loading" indeterminate />
                    <span v-else-if="noBillingAccount">
                      <template v-if="hasTrialService">
                        {{ $t('heading.billing.details.trialInfo') }}
                        <v-btn
                          v-if="trialUpgradeUrl"
                          class="mt-2"
                          :href="trialUpgradeUrl"
                          target="_blank"
                          small
                          block
                          elevation="0"
                          color="warning"
                        >
                          <span class="white--text">{{
                            $t("button.upgradeNow")
                          }}</span>
                        </v-btn>
                      </template>
                      <template v-else>
                        {{ $t('heading.billing.details.firstPaymentInfo') }}
                      </template>
                    </span>
                    <ul v-else class="text--gray-darken1">
                      <li class="font-weight-bold text--darken2">
                        {{ details.companyname }}
                      </li>
                      <li>{{ details.firstname }} {{ details.lastname }}</li>
                      <li>{{ details.address1 }}</li>
                      <li>{{ details.postcode }} {{ details.city }}</li>
                      <li>{{ details.state }}</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            lg="10"
            :class="$vuetify.breakpoint.lgAndDown ? `` : 'pl-12'"
          >
            <v-container class="container px-0 pb-8">
              <v-row
                class="title-row"
                :class="`${
                  $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
                }`"
              >
                <v-col class="d-flex align-center">
                  <h4 class="font-weight-light">
                    {{ $t('heading.billing.invoice.title') }}
                  </h4>
                </v-col>

                <v-col
                  class="page-title__filter-controls justify-end"
                  :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
                >
                  <data-iterator-filter-controls
                    :showSearchTerm="true"
                    :searchTerm="searchTerm"
                    @update:searchTerm="handleSearchTermChange"
                    @update:sortBy="changeSortBy"
                    @update:sortDesc="handleSortDescChange"
                  ></data-iterator-filter-controls>
                </v-col>
              </v-row>
            </v-container>
            <!-- <InvoicesTable :loading="loading" :items="items"/> -->
            <InvoicesTable
              :headers="headers"
              :items="items"
              :loading="loading"
              :itemsPerPage="itemsPerPage"
              :page="page"
              :possibleItemsPerPage="[[10, 20, 30]]"
              :sortBy="sortBy"
              :sortDesc="sortDesc"
              :searchTerm="searchTerm"
              @update:searchTerm="handleSearchTermChange"
              @update:check-all="handleSelectAll"
              @update:checked-items="handleItemCheck"
              @update:itemsPerPage="changePerPage"
              @update:page="changePage"
              @update:sortBy="changeSortBy"
              @update:sortDesc="changeSortDesc"
            />
            <!-- <InvoicesTable 
              :headers="headers"
              :items="items"
              :itemsPerPage="itemsPerPage"
              :page="page"
              :possibleItemsPerPage="[[10, 20, 30]]"
              :sortBy="sortBy"
              :sortDesc="sortDesc"
              :searchTerm="searchTerm"
            /> -->
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Api from "@/apis/Api";

import InvoicesTable from "../components/dataIterator/tables/InvoicesTable.vue";
import DataIteratorPageMixin from "../mixins/DataIteratorPageMixin";
import CustomTablePageMixin from "../mixins/CustomTablePageMixin";
import DataIteratorFilterControls from "../components/dataIterator/DataIteratorFilterControls.vue";
import NoAvailableInvoicesView from "../components/NoAvailableInvoicesView.vue";

export default {
  components: {
    InvoicesTable,
    DataIteratorFilterControls,
    NoAvailableInvoicesView
  },
  mounted() {
    if (!this.billingEnabled) {
      this.$router.push({ path: "/instances" });
      return;
    }
    this.loadDetails();
  },
  mixins: [DataIteratorPageMixin, CustomTablePageMixin],
  data() {
    return {
      noBillingAccount: false,
      details: {
        firstname: "",
        lastname: "",
        companyname: "",
        address1: "",
        postcode: "",
        city: "",
        state: "",
        country: "",
        services: [],
      },
      sortBy: {
        text: "number",
        align: "start",
        value: "id",
        sortable: true,
      },
      checkedItems: [],
      items: [],
      allItems: [],
      page: 1,
      itemsPerPage: 10,
      loading: false,
      searchTerm: "",
      itemsTotal: 0,
    };
  },
  computed: {
    trialService() {
      return this.$store.state.services.getTrialService();
    },
    hasTrialService() {
      return !!this.trialService;
    },
    trialUpgradeUrl() {
      if (this.trialService?.is_trial) {
        return this.trialService.plan_upgrade_link;
      }
      return "";
    },
    billingEnabled() {
      if (this.$store.state.home?.app?.billing_enabled) {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadDetails() {
      this.loading = true;
      Api.get("/billing")
        .then((response) => {
          if (response.data.data === null) {
            this.noBillingAccount = true;
            return;
          }
          this.details = response.data.data;
          this.items = this.details.invoices;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.loadDetails();
    },
    changePerPage(perPage) {
      this.page = 1;
      this.itemsPerPage = perPage;
      this.loadDetails();
    },
    changeSortBy: function (data) {
      this.page = 1;
      this.sortBy = data;
      this.loadDetails();
    },
    changeSortDesc: function (data) {
      this.page = 1;
      this.sortDesc = data;
      this.loadDetails();
    },
    handleSearchTermChange: function (newValue) {
      this.page = 1;
      this.searchTerm = newValue;
      this.loadDetails();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
